import Graticule from 'ol/layer/Graticule';
import { LIGHT_CONDITION } from '../utils/constantes'
import {
  GRATICULE_TEXT_LON_DAY,
  GRATICULE_TEXT_LON_DUSK,
  GRATICULE_TEXT_LON_NIGHT,
  GRATICULE_TEXT_LAT_DAY,
  GRATICULE_TEXT_LAT_DUSK,
  GRATICULE_TEXT_LAT_NIGHT,
  GRATICULE_GRID_STROKE_DAY,
  GRATICULE_GRID_STROKE_DUSK,
  GRATICULE_GRID_STROKE_NIGHT,
} from '../utils/styles/styles';

/**
 * Sytled graticule.
 * @extends {Graticule}
 */
export default class GeomodGraticule extends Graticule {
  /**
	 * @constructor
	 */
  constructor(options = {}) {
    super({ ...options, showLabels: true });

    this.setColorMode(LIGHT_CONDITION.DAY);
  }

  activateGraticule(map) {
    this.setMap(map);
  }

  /**
	 * Change de graticule color mode.
	 * @param {LIGHT_CONDITION} colorMode The color mode. Possible color mode are day, dusk, night.
	 */
  setColorMode(colorMode) {
    switch (colorMode) {
      case LIGHT_CONDITION.DAY:
        this.lineStyle_ = GRATICULE_GRID_STROKE_DAY;
        this.lonLabelStyleBase_ = GRATICULE_TEXT_LON_DAY;
        this.latLabelStyleBase_ = GRATICULE_TEXT_LAT_DAY;
        break;
      case LIGHT_CONDITION.DUSK:
        this.lineStyle_ = GRATICULE_GRID_STROKE_DUSK;
        this.lonLabelStyleBase_ = GRATICULE_TEXT_LON_DUSK;
        this.latLabelStyleBase_ = GRATICULE_TEXT_LAT_DUSK;
        break;
      case LIGHT_CONDITION.NIGHT:
        this.lineStyle_ = GRATICULE_GRID_STROKE_NIGHT;
        this.lonLabelStyleBase_ = GRATICULE_TEXT_LON_NIGHT;
        this.latLabelStyleBase_ = GRATICULE_TEXT_LAT_NIGHT;
        break;
      default:
        break;
    }
  }
}
